export const firebaseConfig = {
  apiKey: "AIzaSyA5pdiKp3BEzzAxnhgyleW_9ZBF7ljLerY",
  authDomain: "engagement-dashboard-7f780.firebaseapp.com",
  projectId: "engagement-dashboard-7f780",
  storageBucket: "engagement-dashboard-7f780.appspot.com",
  messagingSenderId: "127102371526",
  appId: "1:127102371526:web:0e1898d09cfaded289f9c7"
};


// WEBPACK FOOTER //
// ./src/firebaseConfig.js